import { MY_SHIFTS_PATH } from "../MyShifts";

export const UNVERIFIED_SHIFTS_PATH = `${MY_SHIFTS_PATH}/unverifiedShifts`;
